import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { DetailsApiFactory } from "../lusca-search-api/LuscaSearchApiFactory";
import { Stage } from "../lusca-search-api/generated-src";
import { CanonicalBusinessEvent } from "../types/cbes";
import { createHerdObjectId } from "../helpers/linkUtils";

export function useHerdErrorDetail(
  cbe: CanonicalBusinessEvent,
  stage: Stage,
  enabled: boolean
): UseQueryResult<string | null> {
  const objectId = createHerdObjectId(cbe);
  return useQuery({
    queryKey: ["herdErrorDetail", stage, objectId],
    enabled: enabled && !!cbe.realm && !!objectId,
    staleTime: Infinity,
    retry: false,
    queryFn: async () => {
      const api = DetailsApiFactory();
      const response = await api.getHerdErrorDetail(
        stage,
        objectId,
        cbe.realm as string
      );
      return response.data?.stackTrace ?? null;
    },
  });
}
